export enum AtomicHeaderType {
  HeadlineSmallOneLine = 'HEADLINE_SMALL_ONE_LINE',
  HeadlineXsmallOneLine = 'HEADLINE_XSMALL_ONE_LINE',
  HeadlineSmallOneLineWithText = 'HEADLINE_SMALL_ONE_LINE_WITH_TEXT',
  HeadlineSmallOneLineWithTextCompact = 'HEADLINE_SMALL_ONE_LINE_WITH_TEXT_COMPACT',
  HeadlineOnlyText = 'HEADLINE_ONLY_TEXT',
  HeadlineSmallTwoLineWithTimer = 'HEADLINE_SMALL_TWO_LINE_WITH_TIMER',
  HeadlineReloadOneLine = 'HEADLINE_RELOAD_ONE_LINE',
  HeadlineLargeTwoLine = 'HEADLINE_LARGE_TWO_LINE',
  HeadlineSmallOneLineCompact = 'HEADLINE_SMALL_ONE_LINE_COMPACT',
  HeadlineOverlineTimer = 'HEADLINE_OVERLINE_TIMER',
  HeadlineSelectableOneLine = 'HEADLINE_SELECTABLE_ONE_LINE',
  HeadlineSmallOneLineToggle = 'HEADLINE_SMALL_ONE_LINE_TOGGLE',
  HeadlineSmallOneLineWithTimer = 'HEADLINE_SMALL_ONE_LINE_WITH_TIMER',
  HeadlineSmallTwoLine = 'HEADLINE_SMALL_TWO_LINE',
  HeadlineXsmallOneLineCompact = 'HEADLINE_XSMALL_ONE_LINE_COMPACT',
  HeadlineXsmallOneLineSegments = 'HEADLINE_XSMALL_ONE_LINE_SEGMENTS',
  HeadlineXsmallOneLineToggle = 'HEADLINE_XSMALL_ONE_LINE_TOGGLE',
}

export enum AtomicFooterType {
  More = 'MORE',
  MoreSmall = 'MORE_SMALL',
}

export enum AtomicItemListType {
  PROFILE_INFO = 'PROFILE_INFO',
  Divider = 'DIVIDER',
  FilterList = 'FILTER_LIST',
  TwoColGoodsList = 'TWO_COL_GOODS_LIST',
  TwoColCardList = 'TWO_COL_CARD_LIST',
  ThreeColGoodsList = 'THREE_COL_GOODS_LIST',
  ThreeColCardList = 'THREE_COL_CARD_LIST',
  GoodsCarousel = 'GOODS_CAROUSEL',
  TwoLineMessage = 'TWO_LINE_MESSAGE',
  Proxy = 'PROXY',
  Empty = 'EMPTY',
  NotificationGuide = 'NOTIFICATION_GUIDE',
  CompanyInfo = 'COMPANY_INFO',
  SearchBar = 'SEARCH_BAR',
  NeonSignBoard = 'NEON_SIGN_BOARD',
  Summary = 'SUMMARY',
  HorizontalChipList = 'HORIZONTAL_CHIP_LIST',
  FourColIconList = 'FOUR_COL_ICON_LIST',
  FiveColIconList = 'FIVE_COL_ICON_LIST',
  ScrollableIconList = 'SCROLLABLE_ICON_LIST',
  MarketBadgeList = 'MARKET_BADGE_LIST',
  StoreList = 'STORE_LIST',
  TwoImageMarketCarousel = 'TWO_IMAGE_MARKET_CAROUSEL',
  ThreeImageMarketCarousel = 'THREE_IMAGE_MARKET_CAROUSEL',
  RollingBannerList = 'ROLLING_BANNER_LIST',
  BannerCarousel = 'BANNER_CAROUSEL',
  DescriptionCardCarousel = 'DESCRIPTION_CARD_CAROUSEL',
  VerticalBannerList = 'VERTICAL_BANNER_LIST',
  TwoColOutfitList = 'TWO_COL_OUTFIT_LIST',
  RelatedEvent = 'RELATED_EVENT',
  MarketBrandingAds = 'MARKET_BRANDING_ADS',
  MultiCheckboxFilter = 'MULTI_CHECKBOX_FILTER',
  TodayRollingBanner = 'TODAY_ROLLING_BANNER',
  TodayShortBanner = 'TODAY_SHORT_BANNER',
  CheckboxFilterList = 'CHECKBOX_FILTER_LIST',
  DownloadableCoupons = 'DOWNLOADABLE_COUPONS',
  DownloadedCoupons = 'DOWNLOADED_COUPONS',
  EventGrid = 'EVENT_GRID',
  ExpandableCategoryList = 'EXPANDABLE_CATEGORY_LIST',
  FlipDescriptionCard = 'FLIP_DESCRIPTION_CARD',
  FrequentlyVisitedMarketList = 'FREQUENTLY_VISITED_MARKET_LIST',
  GoodsCarouselCalendar = 'GOODS_CAROUSEL_CALENDAR',
  HorizontalImageChipList = 'HORIZONTAL_IMAGE_CHIP_LIST',
  InputNonEntryMarket = 'INPUT_NON_ENTRY_MARKET',
  OneCheckboxFilter = 'ONE_CHECKBOX_FILTER',
  OutfitCarousel = 'OUTFIT_CAROUSEL',
  PromotionShortBanner = 'PROMOTION_SHORT_BANNER',
  SortingGoodsList = 'SORTING_GOODS_LIST',
  TasteOnboardingCard = 'TASTE_ONBOARDING_CARD',
  ThreeColFilter = 'THREE_COL_FILTER',
  TwoColBrandGoodsList = 'TWO_COL_BRAND_GOODS_LIST',
  TwoColFeaturedShortcutList = 'TWO_COL_FEATURED_SHORTCUT_LIST',
}
